<template>
  <div class="position-box">
    <div class="cotainer propagateBuy">
      <div class="header">
        <img class="header-back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
        <img class="header-back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        <span>{{profit.name}}</span>
      </div>
      <div class="cont-box bzhlPay">
        <ul class="item-wrap">
          <li class="item-box">
            <div class="t1">
              {{ $t("bzhlgm.rsyl") }}
            </div>
            <div class="t2 syl">{{ profit.rate_win }}</div>
          </li>
          <li class="item-box">
            <div class="t1">{{ $t("bzhl.dbxe") }}</div>
            <div class="t2">{{ profit.moneylimit }}</div>
          </li>
        </ul>
        <div class="bg"></div>
        <div class="week-wrap">
          <div class="week2-box">
            <div>
              <p class="t1">{{ $t("bzhlgm.tgzj") }}</p>
              <p class="t2">{{ profit.info_tgtype }}</p>
            </div>
            <div>
              <p class="t1">{{ $t("bzhlgm.tqsh") }}</p>
              <p class="t2">{{ profit.rate_back }}%</p>
            </div>
          </div>
        </div>
        <div class="bg"></div>
        <div class="week5-box" v-if="lang == 'ar'">
          <div class="title">{{ $t("bzhlgm.tgje") }}</div>
          <div class="input-wrap">
            <div class="t2" @click="all">{{ $t("bzhlgm.qb") }}</div>
            <div class="input-box">
              <input
                class="input number"
                type="text"
                v-model="money"
                @keyup="keyMoney()"
                :placeholder="$t('bzhl.dbxe') + moneylimit"
                autocomplete="off"
              />
            </div>
            <div class="t1">{{currency}}</div>
          </div>
        </div>
        <div class="week5-box" v-else>
          <div class="title">{{ $t("bzhlgm.tgje") }}</div>
          <div class="input-wrap">
            <div class="input-box">
              <input
                class="input number"
                type="text"
                v-model="money"
                @keyup="keyMoney()"
                :placeholder="$t('bzhl.dbxe') + moneylimit"
                autocomplete="off"
              />
            </div>
            <div class="t1">{{currency}}</div>
            <div class="t2" @click="all">{{ $t("bzhlgm.qb") }}</div>
          </div>
        </div>
        <div class="btn-box">
          <button class="btn btn-bg" type="button" @click="buy">
            {{ $t("bzhlgm.rm") }}
          </button>
        </div>
      </div>
      <div class="mask" v-show="isShow"></div>
      <div class="alert-pwd-box" v-show="isShow">
          <div class="alert-head">{{$t('tips.qsrjymm')}}</div>
          <img class="close" src="@/assets/close2.png" @click="close" alt="">
          <ul class="pwd-box">
              <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "propatateBuy",
  data() {
    return {
      id: "",
      isMore: false,
      isShow: false,
      useBalance: "",
      money: "",
      profit: {},
      moneylimit: "",
      inputList: [
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
      ],
      theme: false,
      currency: '',
      count: 1,
      lang: 'en'
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.currency = localStorage.getItem('sbsxbz') || 'USDT';
    this.theme = JSON.parse(localStorage.getItem('theme'));
    this.lang = localStorage.getItem('language') || 'en';
  },
  mounted() {
    this.getAsset();
    this.getProfitInfo()
  },
  methods: {
    back() {
      this.$router.push("/propagate");
    },
    rule() {
      this.$router.push("/rule");
    },
    getAsset(){
      let that = this;
      let params = {
        id: 1
      }
      this.$ajax.get('/web/getAsset2',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 1000){
            setTimeout(()=>{
              this.$router.push('/login');
            },1000)
            return false
          }
          this.useBalance =  (Number(resData.list.filter(item =>{
            return item.currency == this.currency
          })[0].positions)).toFixed(4);
      }).catch(function(err){
          console.log(err)
      })
    },
    getProfitInfo(){
      let params = {
        id: this.id
      }
      this.$ajax.get('/web/getProfitInfo',{params}).then((res) => {
          let resData = res.data.data;
          this.profit = resData;
          this.moneylimit = resData.moneylimit
      }).catch(function(err){
          console.log(err)
      })
    },
    buy(){
      var limitStart = parseFloat(this.profit.moneylimit.split('-')[0]);
      var limitEnd = parseFloat(this.profit.moneylimit.split('-')[1]);
      if(!this.money || this.money == null){
        this.$toast.center(this.$t('bzhl.dbxe') + this.profit.moneylimit);
        return;
      }else if(parseFloat(this.money) < limitStart){
        this.$toast.center(this.$t('bzhl.dbxe') + this.profit.moneylimit);
        return;
      }else if(parseFloat(this.money) > limitEnd){
        this.$toast.center(this.$t('bzhl.dbxe') + this.profit.moneylimit);
        return;
      }
      this.isShow = true;
    },
    nextFocus(el,index) {
      var dom = document.getElementsByClassName("pwd-input"),
        currInput = dom[index],
        nextInput = dom[index + 1],
        lastInput = dom[index - 1];
      /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
      if(el.keyCode != 8) {
        if(dom[0].value == ''){
            dom[0].value = this.inputList[0].val = currInput.value;
            currInput.value = this.inputList[index].val ='';
            dom[0].blur();
            dom[1].focus();
        }
        if(currInput.value == '') return;
        if(index < (this.inputList.length - 1)) {
            nextInput.focus();
        }else {
            currInput.blur();
        }
      }else{
          if(index != 0) {
            lastInput.focus();
          }
      }
      let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
      if(password.length == 6){
        let params = {
          profit: this.id,
          amount: this.money,
          tpassword: password
        }
        if(this.count == 1){
          this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post('/web/buyProfit',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                  this.count = 1;
                  this.$router.push('/propagate')
                }, 1000)
            }else{
                this.count = 1;
                this.isShow = false;
                this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                this.$toast.center(resData.message);
                return;
            }
        }).catch(function(err){
            console.log(err)
        })
      }else{
        return false;
      }
    },
    keyMoney(){
        this.money = this.money.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.money = this.money.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.money = this.money.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.money = this.money.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.money.indexOf(".") < 0 && this.money != "") { //首位是0的话去掉
            this.money = parseFloat(this.money);
        }
    },
    all(){
      this.money = this.useBalance;
    },
    close() {
      this.isShow = false;
      this.inputList = [
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
        { val: "" },
      ];
    },
    all(){
      this.money = this.useBalance;
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.header {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: .56rem;
}
.header .header-back {
  position: absolute;
  left: .3rem;
  width: .5rem;
}
.cont-box {
  position: absolute;
  top: 1.2rem;
  bottom: 1.5rem;
  width: 100%;
  height: auto;
  background: #fff;
  overflow-y: scroll;
}
.cont-box .item-wrap {
  display: flex;
  align-items: stretch;
  padding: .3rem .42rem .18rem .3rem;
  font-size: .42rem;
  color: #000;
}
.cont-box .item-wrap .item-box{
  width: 50%;
}
.cont-box .item-wrap .item-box .t1 {
  padding-bottom: .54rem;
  color: #656565;
}
.cont-box .item-wrap .item-box .syl {
  color: #e02626;
  font-size: .66rem;
  font-weight: bold;
}
.cont-box .item-wrap .item-box .t2 {
  padding-bottom: .48rem;
}
.cont-box .item-wrap .item-box:last-child {
  padding-left: .3rem;
}
.rule-wrap {
  padding: 0 .42rem .3rem;
}
.rule-box {
  display: flex;
  align-items: center;
  padding: .48rem .42rem .42rem .454rem;
  color: #89785f;
  font-size: .42rem;
  background: #fff8e6;
  border-radius: .2rem;
}
.rule-box .icon1 {
  width: .84rem;
}
.rule-box .text {
  flex: 1;
  padding: 0 .54rem;
}
.rule-box .icon2 {
  width: .18rem;
}
.bg {
  width: 100%;
  height: .27rem;
  background: #f4f5f7;
}
.pro-cycle {
  padding: .6rem .48rem .84rem;
  font-size: .48rem;
}
.pro-item1-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .48rem;
}
.pro-item1-box .pro-item {
  width: .3rem;
  height: .3rem;
  background: #c69651;
  border-radius: 50%;
}
.pro-item1-box .pro-item1 {
  flex: 1;
  height: 2px;
  margin: 0 .18rem;
  background: #c69651;
}
.pro-item2-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .42rem .48rem .54rem;
  font-size: .36rem;
}
.pro-item2-box .pro-item {
  width: 33.33%;
}
.pro-item2-box .t2 {
  padding-top: .3rem;
}
.week-wrap {
  padding: 0 .24rem .72rem;
  background: #fff;
}
.week-wrap .week1-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: -.48rem;
  padding: .36rem .78rem .36rem 1.5rem;
  border-radius: .12rem;
  background: #fff;
}
.week-wrap .week1-box .center {
  text-align: center;
}
.week-wrap .week1-box .t1 {
  color: #000;
  font-size: .45rem;
}
.week-wrap .week1-box .t2 {
  margin-top: .24rem;
  color: #757575;
  font-size: .45rem;
}
.week-wrap .week2-box {
  display: flex;
  justify-content: space-around;
  margin-top: .27rem;
  padding: .48rem .2rem 0;
}
.week-wrap .week2-box .t1 {
  color: #656565;
  font-size: .36rem;
  text-align: center;
}
.week-wrap .week2-box .t2 {
  margin-top: .54rem;
  color: #000;
  font-size: .48rem;
  text-align: center;
}
.week3-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: .18rem .24rem 0;
  padding: .36rem 1.08rem .48rem 1.2rem;
  background: #2e6cc8;
}
.week3-box .t1 {
  color: #a2cbff;
  text-align: center;
}
.week3-box .t2 {
  margin-top: .3rem;
  color: #fff;
  font-weight: bold;
  text-align: center;
}
.week4-box .week-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .42rem .54rem .42rem .48rem;
  color: #000;
}
.week4-box .week-list .arrow {
  width: .3rem;
  height: .3rem;
  margin-top: -.18rem;
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  transform: rotate(135deg);
}
.week4-box .week-list .arrow.active {
  margin-top: .18rem;
  transform: rotate(-45deg);
}
.week4-box .cont {
  padding: .12rem 0 1.05rem .48rem;
}
.week5-box {
  padding: .54rem .36rem;
}
.week5-box .title {
  color: #000;
  font-size: .48rem;
}
.week5-box .input-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: .36rem;
  padding: .36rem 0;
  background: #f4f5f7;
  border-radius: .2rem;
}
.week5-box .input-wrap .input-box {
  flex: 1;
}
.week5-box .input-wrap .input-box .input {
  width: 100%;
  text-indent: .3rem;
}
.week5-box .input-wrap .t1 {
  padding: 0 .24rem;
  color: #000;
}
.week5-box .input-wrap .t2 {
  padding: 0 .36rem 0 .24rem;
  color: #588bf8;
  border-left: 1px solid #e5e5e5;
}
.btn-box {
  position: fixed;
  bottom: .36rem;
  width: 100%;
  padding: 0 .24rem;
  box-sizing: border-box;
}
.btn-box .btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/propagateBuy.vue